/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractFilterQueryDto
 */
export interface ContractFilterQueryDto {
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterQueryDto
     */
    includeBinder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractFilterQueryDto
     */
    submissionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterQueryDto
     */
    includeSubmission?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterQueryDto
     */
    includeLayer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterQueryDto
     */
    includeReinsured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterQueryDto
     */
    includeBroker?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractFilterQueryDto
     */
    isMyContract?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ContractFilterQueryDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractFilterQueryDto
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractFilterQueryDto
     */
    pinnacleRefNo?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractFilterQueryDto
     */
    legacyPinRefNo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    insuredIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    reinsuredIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    brokerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    binderIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    lineOfBusinesses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    underwriterIds?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContractFilterQueryDto
     */
    underwritingYears?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFilterQueryDto
     */
    statuses?: Array<ContractFilterQueryDtoStatusesEnum>;
}


/**
 * @export
 */
export const ContractFilterQueryDtoStatusesEnum = {
    Bound: 'Bound',
    NotTakenUp: 'Not Taken Up',
    Cancelled: 'Cancelled',
    Quoted: 'Quoted',
    Pending: 'Pending'
} as const;
export type ContractFilterQueryDtoStatusesEnum = typeof ContractFilterQueryDtoStatusesEnum[keyof typeof ContractFilterQueryDtoStatusesEnum];


/**
 * Check if a given object implements the ContractFilterQueryDto interface.
 */
export function instanceOfContractFilterQueryDto(value: object): value is ContractFilterQueryDto {
    return true;
}

export function ContractFilterQueryDtoFromJSON(json: any): ContractFilterQueryDto {
    return ContractFilterQueryDtoFromJSONTyped(json, false);
}

export function ContractFilterQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractFilterQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'includeBinder': json['includeBinder'] == null ? undefined : json['includeBinder'],
        'submissionId': json['submissionId'] == null ? undefined : json['submissionId'],
        'includeSubmission': json['includeSubmission'] == null ? undefined : json['includeSubmission'],
        'includeLayer': json['includeLayer'] == null ? undefined : json['includeLayer'],
        'includeReinsured': json['includeReinsured'] == null ? undefined : json['includeReinsured'],
        'includeBroker': json['includeBroker'] == null ? undefined : json['includeBroker'],
        'isMyContract': json['isMyContract'] == null ? undefined : json['isMyContract'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'pinnacleRefNo': json['pinnacleRefNo'] == null ? undefined : json['pinnacleRefNo'],
        'legacyPinRefNo': json['legacyPinRefNo'] == null ? undefined : json['legacyPinRefNo'],
        'insuredIds': json['insuredIds'] == null ? undefined : json['insuredIds'],
        'reinsuredIds': json['reinsuredIds'] == null ? undefined : json['reinsuredIds'],
        'brokerIds': json['brokerIds'] == null ? undefined : json['brokerIds'],
        'binderIds': json['binderIds'] == null ? undefined : json['binderIds'],
        'lineOfBusinesses': json['lineOfBusinesses'] == null ? undefined : json['lineOfBusinesses'],
        'underwriterIds': json['underwriterIds'] == null ? undefined : json['underwriterIds'],
        'underwritingYears': json['underwritingYears'] == null ? undefined : json['underwritingYears'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
    };
}

export function ContractFilterQueryDtoToJSON(json: any): ContractFilterQueryDto {
    return ContractFilterQueryDtoToJSONTyped(json, false);
}

export function ContractFilterQueryDtoToJSONTyped(value?: ContractFilterQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'includeBinder': value['includeBinder'],
        'submissionId': value['submissionId'],
        'includeSubmission': value['includeSubmission'],
        'includeLayer': value['includeLayer'],
        'includeReinsured': value['includeReinsured'],
        'includeBroker': value['includeBroker'],
        'isMyContract': value['isMyContract'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'pinnacleRefNo': value['pinnacleRefNo'],
        'legacyPinRefNo': value['legacyPinRefNo'],
        'insuredIds': value['insuredIds'],
        'reinsuredIds': value['reinsuredIds'],
        'brokerIds': value['brokerIds'],
        'binderIds': value['binderIds'],
        'lineOfBusinesses': value['lineOfBusinesses'],
        'underwriterIds': value['underwriterIds'],
        'underwritingYears': value['underwritingYears'],
        'statuses': value['statuses'],
    };
}

